<template>
  <div class="newStudent" v-if="infoObj.addWeTime">
    <div class="studentInfo">
      <img src="@/assets/images/studentCardBg.png" alt="" class="studentCard" />
      <div class="pasteTag" v-if="!infoObj.tel && infoObj.addWeTime" @click="addTelRoute">
        <img src="@/assets/images/pasteTag.png" alt="" />
        <span>电话补录</span>
      </div>
      <div class="card">
        <dl class="item_student">
          <span>昵称：</span>
          <span>{{ infoObj.name || "无" }}</span>
        </dl>
        <dl class="item_student">
          <span>手机号：</span>
          <!-- <span>{{ infoObj.tel || "无" }}</span> -->

          <span>{{ showTel && showTel != "123456" ? showTel : "无" }}</span>

          <van-icon v-if="infoObj.tel && infoObj.tel.split(',').length > 1" name="play" @click="changePop" />
        </dl>
        <dl class="item_student">
          <span>意向学科：</span>
          <span>{{ infoObj.stuName || "无" }}</span>
        </dl>
        <dl class="item_student">
          <span>加微时间：</span>
          <span>{{ infoObj.addWeTime || "无" }}</span>
        </dl>
      </div>
    </div>
    <div class="panelTab">
      <van-tabs class="tab_customer" v-model="activeName" @click="onClickTab">
        <van-tab name="qwInfo" title="企微信息"></van-tab>

        <van-tab name="studentInfo" v-if="infoObj.tel" title="招生状态"></van-tab>
        <van-tab v-if="infoObj.tel" name="recodeInfo" title="跟单记录"></van-tab>
      </van-tabs>
    </div>
    <!--企微信息tab-->
    <div class="qwInfo" v-show="activeName === 'qwInfo'">
      <!--标签-->
      <div class="public_card">
        <h4>标签</h4>
        <div class="pasteTag" @click="openlabel">
          <img src="@/assets/images/pasteTag.png" alt="" />
          <span>打标签</span>
        </div>
        <!--没有标签显示-->
        <div class="tagCount_wrap" v-if="tagIds.length > 0">
          <div class="public_tag addTeacGrou tagList">
            <span v-for="item in tagIds" :key="item.id">{{ item.name }}</span>
          </div>
          <p class="show" @click="expandClick">
            {{ "展开全部标签(" + tagIds.length + ")" }}
            <van-icon name="play" />
          </p>
        </div>
        <p v-else class="tagNone">暂无标签</p>
      </div>
      <!--关联企微老师-->
      <div class="public_card">
        <h4>关联企微老师</h4>
        <div class="tagCount_wrap" v-if="infoObj.userList.length > 0">
          <div class="public_tag addTeacGrou">
            <span v-for="(line, i) in infoObj.userList" :key="i">
              {{ line.firstUserName }}
            </span>
          </div>
          <p class="show" @click="expandClick">
            {{ "展开全部老师(" + infoObj.userList.length + ")" }}
            <van-icon name="play" />
          </p>
        </div>
        <p v-else class="tagNone">暂无关联企微老师</p>
      </div>
      <!--关联企微群组-->
      <div class="public_card">
        <h4>关联企微群组</h4>
        <div class="tagCount_wrap" v-if="infoObj.groupList.length > 0">
          <div class="public_tag addTeacGrou">
            <span v-for="item in infoObj.groupList.filter((v) => v.delFlag !== 1)" :key="item.groupName">{{ item.groupName }}</span>
          </div>
          <p class="show" @click="expandClick">
            {{ "展开全部群组(" + infoObj.userList.length + ")" }}
            <van-icon name="play" />
          </p>
        </div>
        <p v-else class="tagNone">暂无关联群组</p>
      </div>
    </div>
    <!-- <van-overlay :show="maskPage" @click="maskPage = false" /> -->
    <!--招生状态-->
    <div class="qwInfo" v-show="activeName === 'studentInfo'">
      <div class="public_card studentActive">
        <div class="zsAskInfo">
          <!-- <dl class="item_student">
            <span>类型：</span>
            <span>{{ zsInfoObj.stuType || "无" }}</span>
          </dl> -->
          <dl class="item_student">
            <span>来源渠道：</span>
            <span>{{ infoObj.stuFrom || "无" }}</span>
          </dl>
          <dl class="item_student">
            <span>所属咨询师：</span>
            <span>{{ infoObj.stuTeacher || "无" }}</span>
          </dl>
          <dl class="item_student">
            <span>咨询师所在部门：</span>
            <span>{{ infoObj.stuTeacherDept || "无" }}</span>
          </dl>
          <dl class="item_student">
            <span>入库招生系统时间：</span>
            <span>{{ formattime(infoObj.zsCreateTime) || "无" }}</span>
          </dl>
          <dl class="item_student">
            <span>渠道影响时间：</span>
            <span>{{ formattime(infoObj.changeTime) || "无" }}</span>
          </dl>
          <dl class="item_student">
            <span>最后一次跟单时间：</span>
            <span>{{ formattime(infoObj.stuGdTime) || "无" }}</span>
          </dl>
          <dl class="item_student">
            <span>状态：</span>
            <span>
              {{ infoObj.status == 1 ? "已报名" : "未报名" }}
            </span>
          </dl>
          <dl class="item_student">
            <span>学员质量：</span>
            <span>{{ zhiliangShow(columns, infoObj) || "无" }}</span>

            <span
              v-if="
                infoObj.wechatId === userId ||
                infoObj.operator === JSON.stringify(zsUserid) ||
                infoObj.kefuId === JSON.stringify(zsUserid) ||
                infoObj.helpStudyIdList.includes(zsUserid)
              "
              @click="openUpdate"
              class="editBtn flex-center"
            >
              <van-icon name="edit" />
              <span>修改</span>
            </span>
            <span
              v-if="
                (infoObj.wechatId === userId ||
                  infoObj.operator === JSON.stringify(zsUserid) ||
                  infoObj.kefuId === JSON.stringify(zsUserid) ||
                  infoObj.helpStudyIdList.includes(zsUserid)) &&
                zhiliangShow(columns, infoObj)
              "
              class="stu-icon"
              @click="openZLRules"
              >学员质量规则 <i class="el-icon-question"></i>
            </span>
          </dl>
        </div>
      </div>
    </div>

    <!--跟单记录-->
    <div class="qwInfo" v-show="activeName === 'recodeInfo'">
      <div class="public_card studentActive">
        <div class="info-title">
          <h4>跟单记录</h4>
          <!-- addRecord -->

          <!-- v-if=" infoObj.wechatId === userId || infoObj.operator ===
          JSON.stringify(zsUserid) || infoObj.kefuId ===
          JSON.stringify(zsUserid) || infoObj.helpStudyIdList.includes(zsUserid)
          " -->
          <div v-if="infoObj.askId" class="pasteTag" @click="goAddRecordPage">
            <img src="@/assets/images/pasteTag.png" alt="" />
            <span>添加</span>
          </div>
          <vants-table :showoperate="true" :option="option" @father="childDialog" tablestyle="tablestyle" :tableData="tableData" />
        </div>
      </div>
    </div>
    <!-- 选择手机号 -->
    <van-popup v-model="showPhone" position="bottom">
      <van-picker show-toolbar title="选择手机号" :columns="phonecolumns" @confirm="phoneConfirm" @cancel="showPhone = false" />
    </van-popup>
    <!--企业标签-->

    <tag-group v-show="isTagList" :isShow="isTagList" appName="student" @appendTag="appendTag" @cancelTag="cancelTag" :checkedTag="tagIds" />

    <!-- 跟单详情 -->
    <van-dialog v-model="showDetail" title="跟单详情" width="80%" class="detail-dialog">
      <div>
        <span>跟单人：</span>
        <span>{{ detailObj.realName }}</span>
      </div>
      <div>
        <span>学员类型：</span>
        <span>{{ traceShow(tracelist, detailObj) }}</span>
      </div>
      <div>
        <span>一级分类：</span>
        <span>{{ detailObj.stairName || "无" }}</span>
      </div>
      <div>
        <span>二级分类：</span>
        <span>{{ detailObj.foxbaseName || "无" }}</span>
      </div>
      <div>
        <span>三级分类：</span>
        <span>{{ detailObj.threeLevelName || "无" }}</span>
      </div>
      <div>
        <span>本次跟单时间：</span>
        <span>{{ handleTime(detailObj.createtime) || "无" }}</span>
      </div>
      <div>
        <span>下次跟单时间：</span>
        <span>{{ handleTime(detailObj.nexttracetime) || "无" }}</span>
      </div>
      <div>
        <span>预计学习时间：</span>
        <span>{{ handleTime(detailObj.planstudytime) || "无" }}</span>
      </div>
      <div>
        <span>本次跟单内容：</span>
        <span>{{ detailObj.remark || "无" }}</span>
      </div>
    </van-dialog>
    <!-- 修改学员质量 -->
    <van-popup v-model="showUpdate" position="bottom">
      <van-picker title="修改学员质量" show-toolbar :columns="columns" value-key="dname" @confirm="onConfirm" @cancel="showUpdate = false" />
    </van-popup>
    <van-dialog v-model="showMess" title="学员质量规则">
      <div class="show-quality">
        <p>
          <span class="qe-title"> A量：</span>
          <span class="qe-text">了解培训/接受学习/学习意向量/年龄学历相符；</span>
        </p>
        <p>
          <span class="qe-title"> B量：</span>
          <span class="qe-text">有转行想法/有学习规划/正在了解或学习相关视频 ；</span>
        </p>

        <p><span class="qe-title"> C量：</span><span class="qe-text">已建立联系/不排斥沟通/需要长期影响（已加微信/QQ）/低年级大学生；</span></p>
        <p><span class="qe-title"> D量：</span><span class="qe-text">暂时联系不上/无效联系方式/排斥培训/排斥沟通/广告商/骂人的/年龄不符/无千锋相关学科且学科跨度大/竞品；</span></p>
        <p>注：学员只能从D量往A量升级，不能降级</p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Toast, Dialog } from "vant";
import moment from "moment";
import tagGroup from "@/views/wegroupsend/tagGroup";
import vantsTable from "@/components/table.vue";
import { wxConfig } from "../fastReply/js/config";
import { addressBar, wefunstatistics } from "@/utils/public";
import { zhilianglist, zsUserInfo, documentaryRecord, addTags, updateZhiLiang, tracelist, getUserInfoNew } from "@/server/api.js";
export default {
  components: { tagGroup, vantsTable },
  data() {
    return {
      activeName: "qwInfo", //切换企微，招生状态，跟单tab
      isTagList: false, //是否显示选择标签页面
      tagIds: [], //打标签id
      infoObj: {
        groupList: [],
        userList: [],
        weUserInfoTagInfosVos: [],
        helpStudyIdList: [],
      },
      phoneFull: "123456",
      zsInfoObj: {},
      showPhone: false,
      showMess: false,
      showPicker: "",
      columns: [],
      phonecolumns: [],
      showTel: "",
      showDetail: false,
      showUpdate: false,
      tracelist: [],
      tableData: [],
      detailObj: {}, //跟单详情
      userId: "",
      wechatUserId: "", // 外部联系人id
      userIdsarr: [],
      maskPage: false,
      windowurl: window.location.href.split("#")[0] || "http://tm-qw.1000phone.net/info",
      jsList: ["getCurExternalContact"],
      // wechatUserId: "wmPpUqDAAAYfkQaLVmFJQjRCmSsIK9TQ",
      zsUserid: "",
      option: {
        column: [
          {
            label: "跟单人",
            tableDataprop: "realName",
          },
          {
            label: "跟单时间",
            tableDataprop: "createtime",
          },
          {
            label: "跟单内容",
            tableDataprop: "remark",
          },
        ],
      },
    };
  },
  // 打开
  async mounted() {
    if (localStorage.getItem("token")) {
      console.log(this.$route.params.refresh);
      wxConfig(this.windowurl, this.jsList).then(() => {
        // 鉴权
        this.userId = localStorage.getItem("userid");
        this.zsUserid = localStorage.getItem("zsUserId");
        this.hasuserid();
        wefunstatistics("2", window.location.href.split("#")[0]);
      });
    } else {
      addressBar("token", this.windowurl);
    }
  },
  methods: {
    //切换tab
    onClickTab(data) {
      this.activeName = data;
    },
    // 打开
    hasuserid() {
      let that = this;
      wx.invoke("getCurExternalContact", {}, function (res) {
        if (res.userId) {
          that.wechatUserId = res.userId;
          that.getUserInfos(); // 学员画像
          that.getZhilianglist(); // 质量列表
          that.gettracelist(); // 学员类型
          if (that.$route.params.refresh === "sure") {
            // 补录刷新
            Dialog.alert({
              title: "提示",
              message: "已提交，请刷新查看",
            }).then(() => {
              that.getUserInfos();
            });
          }
        }
      });
    },

    // 企微详情
    getUserInfos(name) {
      this.infoObj.userList = [];
      this.tagIds = [];
      let formdata = new FormData();
      formdata.append("userId", this.userId);
      formdata.append("stuId", this.wechatUserId);
      formdata.append("tel", this.showTel || "123456");
      getUserInfoNew(formdata).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        this.infoObj = res.data;
        this.infoObj.weUserInfoTagInfosVos = res.data.weUserInfoTagInfosVos || [];
        this.infoObj.userList = res.data?.userList.filter((item) => !item.lostTime || item.trackState !== 5);
        this.infoObj.weUserInfoTagInfosVos.map((v) => {
          this.tagIds.push({ id: v.tagId, name: v.tagName });
        });
        this.phonecolumns = this.infoObj?.tel?.split(",") || [];
        this.showTel = this.showTel || this.phonecolumns[0] || "123456";
        // this.phoneFull =
        //   this.phoneFull || this.infoObj?.telFjm.split(",")[0] || "";
        if (res.data.askId) {
          this.recordLog();
        }

        this.$nextTick(() => {
          // 修改质量后不切换
          this.activeName = name || this.$route.params.tabname || "qwInfo";
          let customerList = document.querySelectorAll(".addTeacGrou");
          for (let x of customerList) {
            if (x.offsetHeight > 90) {
              x.classList.add("overFlow");
              x.nextElementSibling.style.display = "block";
            }
          }
        });
      });
    },
    // 招生信息状态
    getZsUserInfo() {
      zsUserInfo({ uuid: this.infoObj.unionid }).then((res) => {
        console.log(res);
        this.zsInfoObj = res.data;
        if (res.data.zsAskId) {
          this.recordLog();
        }
      });
    },
    openlabel() {
      this.isTagList = true;
    },
    changePop() {
      this.showPhone = true;
    },
    // 更换手机号
    phoneConfirm(value) {
      this.showPhone = false;
      this.showTel = value || "123456";
      // this.phoneFull = this.infoObj?.telFjm?.split(",")[i] || "123456";
      this.getUserInfos();
    },
    //点击展开
    expandClick(e) {
      let element = e.target;
      element.previousElementSibling.classList.remove("overFlow");
      element.style.display = "none";
    },
    // 质量列表
    getZhilianglist() {
      zhilianglist().then((res) => {
        this.columns = res.data;
      });
    },
    // 跟单记录
    recordLog() {
      documentaryRecord({ askId: this.infoObj.askId }).then((res) => {
        this.tableData = res.data;
      });
    },
    childDialog(obj) {
      this.showDetail = true;
      // console.log(obj);
      this.detailObj = obj;
    },
    //打开标签
    async appendTag(val, bool) {
      this.tagIds = [];
      for (let i of val) {
        this.tagIds.push({
          id: i.id,
          name: i.name,
        });
      }
      let tagsIds = val.map((v) => v.id);
      addTags({
        externalUserId: this.wechatUserId,
        tagsIds,
        userId: this.userId,
      }).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        Toast.success("成功");
        this.getUserInfos();
        this.$nextTick(() => {
          let customerList = document.querySelectorAll(".tagList");
          for (let x of customerList) {
            if (x.offsetHeight > 90) {
              x.classList.add("overFlow");
              x.nextElementSibling.style.display = "block";
            }
          }
        });
        //请求成功后 隐藏弹框
        this.isTagList = bool;
      });
    },

    //取消选择标签
    cancelTag(bool) {
      this.isTagList = bool;
    },
    goAddRecordPage() {
      this.$router.push({
        path: "/addRecord",
        query: {
          askId: this.infoObj.askId,
          kefuId: this.infoObj.kefuId,
        },
      });
    },
    //电话补录
    addTelRoute() {
      this.$router.push({ path: "/addTel" });
      localStorage.setItem("externalUserid", this.wechatUserId);
    },
    openUpdate() {
      this.showUpdate = true;
    },
    // 修改质量
    onConfirm(value) {
      if (this.infoObj.zhiliang > value.did) {
        return Toast.fail("抱歉，不能进行降级修改");
      }
      if (this.infoObj.askId) {
        updateZhiLiang({
          askId: this.infoObj.askId,
          zhiliangID: value.did,
        }).then((res) => {
          // console.log(res);
          if (res.code !== "200") return Toast.fail(res.msg);
          Toast.success("修改成功");
          this.showUpdate = false;
          this.getUserInfos("studentInfo");
        });
      }
    },
    zhiliangShow(zhilianglist, infoObj) {
      if (zhilianglist && zhilianglist.length > 0) {
        let item = zhilianglist.find((item) => item.did === Number(infoObj.zhiliang));
        return item && item.dname;
      }
    },
    traceShow(tracelist, detailObj) {
      if (tracelist && tracelist.length > 0) {
        let item = tracelist.find((item) => item.did === Number(detailObj.type));
        return item && item.dname;
      }
    },
    linkServercard() {
      this.$router.push({
        path: "/servercard",
        query: {
          userId: this.wechatUserId,
          name: this.infoObj.name,
        },
      });
    },
    gettracelist() {
      tracelist().then((res) => {
        this.tracelist = res.data;
      });
    },
    //点击详情
    checkDetail(val) {
      this.showDetail = true;
      this.detailObj = { ...val };
    },
    handleTime(time) {
      if (!time) return false;
      return time.slice(0, 10);
    },
    openZLRules() {
      // Dialog.alert({
      //   title: "学员质量规则",
      //   message:
      //     "A量：了解培训/接受学习/学习意向量/年龄学历相符；<br/>B量：有转行想法/有学习规划/正在了解或学习相关视频 ；<br/>C量：已建立联系/不排斥沟通/需要长期影响（已加微信/QQ）/低年级大学生；<br/>D量：暂时联系不上/无效联系方式/排斥培训/排斥沟通/广告商/骂人的/年龄不符/无千锋相关学科且学科跨度大/竞品；<br/>注：学员只能从D量往A量升级，不能降级",
      //   messageAlign: "left",
      // }).then(() => {
      //   // on confirm
      // });
      this.showMess = true;
    },
    formattime(time) {
      if (time) {
        return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      }
      return "";
    },
  },
};
</script>
<style scoped lang="less">
@import "./css/student.less";
.stu-icon {
  margin-left: 10px;
  font-size: 12px;
}
</style>
